import React, { Fragment, useRef, useEffect } from 'react'
import JsBarcode from 'jsbarcode'

const Barcode = ({ value, options, style }) => {
  const barcodeRef = useRef(null)

  useEffect(() => {
    if (barcodeRef.current) {
      try {
        JsBarcode(barcodeRef.current, value, {
          format: 'CODE39',
          lineColor: '#000',
          width: 1.3,
          height: 25,
          displayValue: false,
          ...options,
        })
      } catch (e) {
        console.error('Error generating barcode', e)
      }
    }
  }, [value, options])

  return (
    <div style={{ zIndex: 1000, ...style }}>
      <svg ref={barcodeRef} />
    </div>
  )
}

export default Barcode
